
import charcol_wallpaper from "../assets/wallpapers/charcol_wallpaper.webp";
import docks_wallpaper from "../assets/wallpapers/docks_wallpaper.webp";
import stone_wallpaper from "../assets/wallpapers/stone_wallpaper.webp";
import wooden_wallpaper1 from "../assets/wallpapers/wooden_wallpaper1.jpeg";
import wooden_wallpaper2 from "../assets/wallpapers/wooden_wallpaper2.jpg";
import wallpaper3 from "../assets/wallpapers/wallpaper3.jpeg";
import tile1 from "../assets/tiles/tile1.jpg";
import tile2 from "../assets/tiles/tile2.jpg";
import tile3 from "../assets/tiles/tile3.jpeg";
import tile4 from "../assets/tiles/tile4.jpeg";
import tile5 from "../assets/tiles/tile5.jpg";
import tile6 from "../assets/tiles/blue.webp";
import tile7 from "../assets/tiles/green.webp";
import tile8 from "../assets/tiles/tile6.jpg";



export const COLORS = [
  "#ffffff",
  "#f8fafc",
  "#facc15",
  "#fb923c",
  "#ef4444",
  "#ec4899",
  "#a855f7",
  "#6366f1",
  "#2563eb",
  "#06b6d4",
  "#10b981",
  "#22c55e",
  "#334155",
  "#111827",
  "#000000",
];

export const WALLPAPERS = [
  {
    id: 1,
    name: "Wooden wallpaper 1",
    image: charcol_wallpaper,
    width_cm: 120,
    height_cm: 240,
  },

  {
    id: 2,
    name: "Wooden wallpaper 2",
    image: wooden_wallpaper2,
    width_cm: 30,
    height_cm: 60,
  },

  {
    id: 3,
    name: "Charcol wallpaper",
    image: wooden_wallpaper1,
    width_cm: 30,
    height_cm: 60,
  },
  {
    id: 4,
    name: "Stone wallpaper",
    image: stone_wallpaper,
    width_cm: 120,
    height_cm: 240,
  },
  {
    id: 5,
    name: "Docks wallpaper",
    image: docks_wallpaper,
    width_cm: 120,
    height_cm: 240,
  },
  {
    id: 6,
    name: "Docks wallpaper",
    image: wallpaper3,
    width_cm: 120,
    height_cm: 240,
  }
];

export const TILES = [
  {
    id: 1,
    name: "Tile1",
    image: tile1,
    width_cm: 30,
    height_cm: 60,
  },
  {
    id: 2,
    name: "Tile2",
    image: tile2,
    width_cm: 30,
    height_cm: 60,
  },
  {
    id: 3,
    name: "Tile3",
    image: tile3,
    width_cm: 30,
    height_cm: 60,
  },
  {
    id: 4,
    name: "Tile4",
    image: tile4,
    width_cm: 30,
    height_cm: 60,
  },
  {
    id: 5,
    name: "Tile5",
    image: tile5,
    width_cm: 30,
    height_cm: 60,
  },
  {
    id: 6,
    name: "Tile6",
    image: tile6,
    width_cm: 60,
    height_cm: 60,
  },
  {
    id: 7,
    name: "Tile7",
    image: tile7,
    width_cm: 80,
    height_cm: 160,
  },
  {
    id: 8,
    name: "Tile8",
    image: tile8,
    width_cm: 30,
    height_cm: 30,
  }
];
